import styled from '@emotion/styled';

import Button from 'components/field/Button';

import { Breakpoints } from 'utils/const.styles';

export const TwoFactorInstallContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 3rem;
	padding: 2rem 1rem;
`;

export const InstallStep = styled.div`
	display: flex;
	flex-direction: row;
	gap: 2rem;
	width: 100%;
	overflow: auto;
`;

export const StepNumber = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 4rem;
	height: 4rem;
	border-radius: 50%;
	background: var(--background-3);
	border: 1px solid var(--background-1);
	flex: 0 0 auto;
`;

export const StepContent = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 2rem;
	width: 100%;
	overflow: auto;
`;

export const QRCodeContainer = styled.div`
	display: flex;
	flex-direction: row;
	border: 1px solid var(--border-color);
	border-radius: var(--spacing-1);
	width: 100%;
`;

export const ManulEntryContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	width: 100%;
	padding: 1rem;
	overflow: auto;
	width: 100%;

	> .form-item {
		padding: 0;
	}
`;

export const TwoFactorDisableModalContainer = styled.div`
	display: flex;
	flex-direction: column;
	padding: 2rem 0;

	@media ${Breakpoints.mobile} {
		padding: 2rem 0.5rem;
	}
`;

export const TwoFactorDisable2FAContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 2rem 0;
	gap: 2rem;

	@media ${Breakpoints.mobile} {
		padding: 2rem 0.5rem;
	}
`;

export const MFABackupCodeButtonContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	gap: 1rem;
	width: fit-content;
	margin: auto;
	flex-wrap: wrap;

	@media ${Breakpoints.mobile} {
		padding: 0;
	}
`;

export const ButtonLink = styled(Button)`
	> .typography {
		text-decoration: underline;
	}
`;

export const TwoFactorDisableWarningContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 3rem;
	gap: 2rem;

	@media ${Breakpoints.mobile} {
		padding: 2rem 1.5rem;
	}
`;

export const TwoFactorBackupCodesModalContainer = styled.div`
	display: flex;
	flex-direction: column;
	padding: 2rem 0;

	@media ${Breakpoints.mobile} {
		padding: 2rem 0.5rem;
	}
`;

export const TwoFactorBackupCodesContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 2rem 1rem;
	gap: 2rem;

	@media ${Breakpoints.mobile} {
		padding: 2rem 1.5rem;
	}
`;

export const TwoFactorBackupCodes2FAContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 2rem 0;
	gap: 2rem;

	@media ${Breakpoints.mobile} {
		padding: 2rem 0.5rem;
	}
`;

export const BackupCodesContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	width: 100%;
	max-width: max-content;
	background-color: var(--background-1);
	border: 1px solid var(--border-color);
	border-radius: var(--spacing-1);

	@media ${Breakpoints.mobile} {
		max-width: unset;
	}
`;

export const BackupCodesWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	row-gap: 3rem;
	column-gap: 5rem;
	padding: 2rem;

	@media ${Breakpoints.mobile} {
		column-gap: unset;
		row-gap: 1rem;
	}
`;

export const BackupCodesButtons = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: stretch;
	border-top: 1px solid var(--border-color);

	> .button {
		flex: 1 0 auto;
	}
`;

export const ButtonsSeparator = styled.div`
	display: flex;
	width: 1px;
	background-color: var(--border-color);
`;

export const PrintContainer = styled.div`
	display: none;

	@media print {
		display: flex;
		flex-direction: column;
		gap: 1rem;
	}
`;
